import Grid from "@material-ui/core/Grid";
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import ThumbDownIcon from '@material-ui/icons/ThumbDown';
import {Dialog, DialogContent, DialogTitle, makeStyles, Typography} from "@material-ui/core";
import React, {useState} from "react";
import Button from "@material-ui/core/Button";
import {red} from "@material-ui/core/colors";
import {Feedback} from "@material-ui/icons";
import useCountryAxiosInstance from "../../hooks/useCountryAxiosInstance";


const useStyles = makeStyles((theme) => ({
  centerDiv: {
    width: "100%",
    textAlign: 'center'
  },
  negativeFeedback: {
    color: red[600],
    backgroundColor: 'transparent',
    variant: "contained",
    border: "none",
    outline: "none",
    '&:hover': {
      backgroundColor: 'transparent',
      color: red[700],
    },
    '&:focus': {
      color: red[700],
      boxShadow: 'none',
      backgroundColor: 'transparent',
    },
    margin: theme.spacing(1)
  },
  positiveFeedback: {
    color: "#87ad84",
    backgroundColor: 'transparent',
    variant: "contained",
    border: "none",
    outline: "none",
    '&:hover': {
      backgroundColor: 'transparent',
      color: "#6f8e6b",
    },
    '&:focus': {
      color: "#6f8e6b",
      boxShadow: 'none',
      backgroundColor: 'transparent',
    },
    margin: theme.spacing(1)
  }
}));

function FaqFeedback({detailedFaq, toggleTicketDialog}) {
  const classes = useStyles();
  const apiRequest = useCountryAxiosInstance();

  const [askOpenTicket, setAskOpenTicket] = useState(false);
  const toggleAskOpenTicket = () => {
    setAskOpenTicket(!askOpenTicket)
  }
  const [value, setValue] = useState(0);

  function useForceUpdate() {
    // integer state
    return () => setValue(value + 1); // update the state to force render
  }

  const forceUpdate = useForceUpdate();

  const giveFeedback = async (positive) => {

    let updateData = {
      "script": {
        "source": "ctx._source.positive_feedback += params.count",
        "lang": "painless",
        "params": {
          "count": 1
        }
      }
    }
    if (positive) {
      detailedFaq._source.positive_feedback = detailedFaq._source.positive_feedback + 1
      updateData.script.source = 'ctx._source.positive_feedback += params.count'
      // updateData.script.params.feedback_ratio = (detailedFaq._source.positive_feedback + 1) /
      //   (detailedFaq._source.positive_feedback + detailedFaq._source.negative_feedback + 1);
    } else {
      detailedFaq._source.positive_feedback = detailedFaq._source.negative_feedback + 1
      updateData.script.source = 'ctx._source.negative_feedback += params.count'
      // updateData.script.params.feedback_ratio = (detailedFaq._source.positive_feedback) /
      //   (detailedFaq._source.positive_feedback + detailedFaq._source.negative_feedback + 1);
      setAskOpenTicket(true);
    }
    apiRequest.post(`/assistant/update_with_script`, {
      "doc_id": detailedFaq._id,
      "doc_script": updateData
    }).then(() => {
      forceUpdate()
    }).catch((err) => {
      console.error("Error when updating feedback count", err)
    })

  }

  return (
    <>
      <Grid container style={{marginTop: 15}}>
        <Grid item xs={12}>
          <div className={classes.centerDiv}>
            <Typography variant='caption'>
              <b>Questa domanda ti è stata utile?</b>
            </Typography>
          </div>
          <Grid item xs={12}>
            <div className={classes.centerDiv}>
              <Button
                className={classes.positiveFeedback}
                // color='primary'
                // variant='contained'
                onClick={() => {
                  giveFeedback(true);
                }}
              ><ThumbUpIcon style={{marginRight: 5}}/>Si
              </Button>

              <Button
                className={classes.negativeFeedback}
                onClick={() => {
                  giveFeedback(false);
                }}

              ><ThumbDownIcon style={{marginRight: 5}}/>No
              </Button>
            </div>
          </Grid>
          <div className={classes.centerDiv}>
            <Typography variant='caption'>
              {detailedFaq._source.positive_feedback} utenti
              su {detailedFaq._source.positive_feedback + detailedFaq._source.negative_feedback - 1} hanno trovato
              utile questa domanda
            </Typography>
          </div>
        </Grid>
      </Grid>
      <Dialog
        open={askOpenTicket}
        onClose={toggleAskOpenTicket}
      >
        <DialogTitle>Il tuo feedback è importante</DialogTitle>
        <DialogContent>
          Se non hai trovato il contenuto che cercavi puoi aprire una <b>segnalazione generica</b>.
        </DialogContent>
        <DialogContent>
          Se pensi che la risposta a questa domanda sia errata puoi chiedere supporto con una <b>segnalazione
          specifica</b>.
        </DialogContent>
        <DialogContent>
          <div style={{textAlign: "center", marginTop: 10}}>
            <Button onClick={toggleAskOpenTicket} variant="contained" style={{float: "left", marginBottom: 10}}>
              Esci
            </Button>
            <Button color="primary" variant="contained" style={{float: "right", marginBottom: 10}}
                    startIcon={<Feedback/>}
                    onClick={() => {
                      toggleTicketDialog(detailedFaq)
                    }}
            >
              Segnalazione sulla domanda
            </Button>
            <Button color="primary" variant="contained" style={{float: "right", marginBottom: 10}}
                    startIcon={<Feedback/>}
                    onClick={() => {
                      toggleTicketDialog()
                    }}
            >
              Segnalazione generica
            </Button>

          </div>
        </DialogContent>
      </Dialog>
    </>
  )
}

export default FaqFeedback;